import { useRef } from "react";
import { useZoomPan } from "./useZoomPan";

export const ZoomableImage = ({ src, alt, onError }) => {
  const imageRef = useRef(null);

  const {
    viewportRef,
    stageRef,
    zoom,
    isPanning,
    isAltPressed,
    imageSize,
    canvasWidth,
    canvasHeight,
    stageLeft,
    stageTop,
    updateSizes,
    handlePointerEnter,
    handlePointerLeave,
    handlePanPointerDown,
    handlePanPointerMove,
    handlePanPointerUp,
  } = useZoomPan({ imageRef, src });

  return (
    <div ref={viewportRef}
         className={`relative h-full w-full ${zoom > 1 ? 'overflow-auto' : 'overflow-hidden'} select-none ${
           isPanning ? 'cursor-grabbing' : isAltPressed ? 'cursor-grab' : ''
         }`}
         onPointerEnter={handlePointerEnter} onPointerLeave={handlePointerLeave}
         onPointerDown={handlePanPointerDown} onPointerMove={handlePanPointerMove} onPointerUp={handlePanPointerUp} onPointerCancel={handlePanPointerUp}>
      <img ref={imageRef} src={src} alt="" className="absolute invisible pointer-events-none" onLoad={updateSizes} onError={onError} draggable={false} />

      {imageSize && (
        <div className="relative" style={{ width: canvasWidth, height: canvasHeight }}>
          <img ref={stageRef} src={src} alt={alt} className="absolute select-none pointer-events-none"
               style={{ left: stageLeft, top: stageTop, width: imageSize.width, height: imageSize.height }} draggable={false} />
        </div>
      )}
    </div>
  );
};